<ng-template #links>
  <ng-content select="w-sticky-bar-link:not([facet-right-side]),li[facet-links]"
    description="list items - w-sticky-bar-link components or li elements that contain links"></ng-content>
</ng-template>
<div class="b-navigation-floater b-landing-background-container" *ngIf="!compactMode"
  [style.opacity]="compactMode!==undefined || version < 2 ?'1':'0.2'" [class.b-navigation-floater--is-sticky]="sticky"
  #floater [ngClass]="landingClass">
  <div class="b-landing-background">
    <ng-content select="f-facet[name=background-image],[facet-background-image]"></ng-content>
  </div>
  <div *ngIf="sticky" class="b-sticky-bg" [style.left.px]="dir==='rtl'?floater.offsetLeft:0"
    [style.right.px]="dir==='rtl'?0:floater.offsetLeft" [style.height]="height" [style.background-color]="bgColor"
    [style.width.px]="2*floater.clientWidth"></div>
  <nav class="b-navigation__in-page-nav" [style.width]="width | async">
    <div class="b-navigation__shortcut-list b-navigation__list b-navigation-header" hide-empty><ng-content
        select="f-facet[name=header],[facet-header]"></ng-content></div>
    <ul class="b-navigation__shortcut-list b-navigation__list">
      <ng-container *ngTemplateOutlet="links"></ng-container>
    </ul>
    <div class="b-flex-grow" #spacer></div>
    <w-button-group hide-empty class="b-navigation__button-group b-navigation__button-group--is-visible">
      <ng-content w-button select="f-facet[name=buttons],[facet-buttons]"
        description="additional size=small buttons"></ng-content>
    </w-button-group>
    <ul class="b-navigation__in-page-nav-list b-navigation__list">
      <ng-content
        select="f-facet[name=right-side],li[facet-right-side],w-sticky-bar-link[facet-right-side],[facet-right-side]"
        description="list items on the right side, either links or other content such as version info"></ng-content>
    </ul>
  </nav>
</div>
<div *ngIf="compactMode" class="b-navigation--mobile-container" [class.b-navigation__selected]="hasSelected"
  [class.b-menu-open]="open" [style.zIndex]="open ? maxZIndex+1 : 0" (click)="linkOrToggle($event)" w-click-outside
  (clickOutside)="open=false">
  <div *ngIf="open" class="b-navigation--mobile-menu-header"></div>
  <div role="list" [class.b-menu-entries]="open">
    <ng-container *ngTemplateOutlet="links"></ng-container>
  </div>
  <i [icon]="'chevron'" class="b-menu-button"></i>
</div>